import StateContent from "../../../../src/components/content-partials/StateContent";
import * as React from 'react';
export default {
  StateContent,
  React
};